/**
 * Reports → Team Members tab (`ReportsTeamMembersTab`).
 * Maps summary VM rows (plan counts, not step counts) → {@link TeamMemberRow}.
 */
import type { TeamMemberRow } from '../teamMemberRow';

/** Input for Reports → Team Members list rows (plan counts, not step counts). */
interface ReportsTeamMemberSummaryInput {
  id?: string;
  displayName: string;
  startDate?: string;
  plansAssigned?: number;
  plansCompleted?: number;
}

export const reportsSummaryToTeamMemberRow = (
  teamMember: ReportsTeamMemberSummaryInput,
): TeamMemberRow => ({
  id: teamMember.id ?? '',
  name: teamMember.displayName,
  displayName: teamMember.displayName,
  filterStatus: '',
  previouslyCompletedPlanAssignmentDate: '',
  timeSpentOnPlan: null,
  percentComplete: 0,
  completedStepCount: teamMember.plansCompleted ?? 0,
  stepCount: teamMember.plansAssigned ?? 0,
  startDate: teamMember.startDate,
});
